export default __webpack_public_path__ + "static/media/chevron.8589f093.svg";